import React from 'react'

const Loader = () => {
    return (
        <div className='page-loader-wrapper position-absolute bg-transparent' style={{display:"block"}}>
            <div className='loader position-fixed'>
                <div className='bar1'></div>
                <div className='bar2'></div>
                <div className='bar3'></div>
                <div className='bar4'></div>
                <div className='bar5'></div>
            </div>
        </div>
    )
}

export default Loader
